import { Component, Input, OnInit } from '@angular/core';
import { UntypedFormBuilder, UntypedFormGroup, ValidatorFn, Validators } from '@angular/forms';
import { DialogContentBase, DialogRef } from '@progress/kendo-angular-dialog';
import { Observable } from 'rxjs';
import { UiNotificationService } from 'src/app/external-ui-shared/services/ui-notification.service';
import { DocumentKind } from 'src/app/shared/model/DocumentKind';
import { FormUtilsService } from 'src/app/shared/services/form-utils.service';
import { ProofDocument } from '../../models/ProofDocument';
import { UploadDocumentParameters, UploadDocumentParametersFormBuilder } from '../../models/UploadDocumentParameters';


@Component({
  selector: 'app-set-claim-documentation-data',
  templateUrl: './set-claim-documentation-data.component.html',
  styleUrls: ['./set-claim-documentation-data.component.scss']
})
export class SetClaimDocumentationDataComponent extends DialogContentBase implements OnInit {

  constructor(public dialog: DialogRef,
      private fb: UntypedFormBuilder,
    private formUtilsService: FormUtilsService,
    private uiNotification: UiNotificationService) {
    super(dialog);
  }

  @Input() uploadDocumentParameters: UploadDocumentParameters;
  proofDocuments$: Observable<ProofDocument[]>;
    documentDataForm: UntypedFormGroup;
  isProofDocument = true;
  selectedDocumentKindId: number;
  otherClaimDocument = DocumentKind.OtherClaimDocument;

  ngOnInit(): void {
    this.documentDataForm = UploadDocumentParametersFormBuilder.getForm(this.fb, this.uploadDocumentParameters);
    this.isProofDocumentValueChanged(true);
  }

  confirm() {

  if(!this.formUtilsService.markFormGroupTouched(this.documentDataForm)) {
    this.uiNotification.showValidationError();
  return;
}

Object.assign(this.uploadDocumentParameters, this.documentDataForm.value);

this.dialog.close({ uploadDocumentParameters: this.uploadDocumentParameters });
  }

isProofDocumentValueChanged(value: any): void {

  const documentKindIdControl = this.documentDataForm.controls['documentKindId'];
  const proofDocumentIdsControl = this.documentDataForm.controls['proofDocumentIds'];
  const otherDocumentKindNameControl = this.documentDataForm.controls['otherDocumentKindName'];

  documentKindIdControl.clearValidators();
  proofDocumentIdsControl.clearValidators();
  otherDocumentKindNameControl.clearValidators();

  if(value) {
    proofDocumentIdsControl.addValidators(Validators.required);
    otherDocumentKindNameControl.setValue(null);
    documentKindIdControl.setValue(null);

  } else {
    documentKindIdControl.addValidators(Validators.required);
    proofDocumentIdsControl.setValue([]);
  }

    documentKindIdControl.updateValueAndValidity();
  proofDocumentIdsControl.updateValueAndValidity();
  otherDocumentKindNameControl.updateValueAndValidity();

}

documentKindChange(value: any): void {

  this.selectedDocumentKindId = value;
  const validators: ValidatorFn[] = [Validators.required];
  const otherDocumentKindNameControl = this.documentDataForm.get('otherDocumentKindName');

  otherDocumentKindNameControl.clearValidators();

  if(value == this.otherClaimDocument) {
  otherDocumentKindNameControl.setValidators(validators);
}

otherDocumentKindNameControl.updateValueAndValidity();
  }

checkIfBasicDocumentKind(item: number) : boolean {

  return DocumentKind.isBasicDocument(item);
}
}